import { Calendar as CalendarIcon, MapPin as MapPinIcon } from "react-feather";
import { useInView } from "react-intersection-observer";
import TicketIcon from "src/assets/images/ticket_icon.svg";
import { useTracking } from "../../../contexts/trackingContext";
import AdaptiveEventImage from "../../molecules/AdaptiveEventImage";

const PortraitItem = ({ event, trackView }) => {
	const { tracker } = useTracking();
	const { ref } = useInView({
		triggerOnce: true,
		skip: !trackView,
		onChange: (inView) => {
			if (trackView && inView) {
				tracker.trackEventView(event, "event_list");
			}
		},
	});

	return (
		<div
			className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm h-[165px] w-full"
			ref={ref}
		>
			<a href={event.absoluteHref} target="_top" className="flex h-full">
				{event.imageUrl && (
					<div className="relative flex w-1/3 max-w-[165px]">
						<AdaptiveEventImage
							src={event.imageUrl}
							alt={event.title}
							loading="lazy"
						/>
					</div>
				)}
				<div className="flex flex-1 flex-col gap-3 px-5 py-4">
					<h3 className="line-clamp-2 text-lg font-bold leading-6 text-slate-800">
						{event.title}
					</h3>
					<div className="flex flex-col gap-1.5">
						<div className="flex items-center gap-3">
							<CalendarIcon size={18} className="min-w-[18px] text-slate-600" />
							<span className="line-clamp-1 text-sm text-slate-700">
								{event.displayDate}
							</span>
						</div>
						{event.locationSummary && (
							<div className="flex items-center gap-3">
								<MapPinIcon size={18} className="min-w-[18px] text-slate-600" />
								<span className="line-clamp-1 text-sm text-slate-700">
									{event.locationSummary}
								</span>
							</div>
						)}
						{event.ticketPriceRange && (
							<div className="flex items-center gap-3">
								<img src={TicketIcon} alt="Ticket icon" />
								<span className="line-clamp-1 text-sm text-slate-700">
									{event.ticketPriceRange}
								</span>
							</div>
						)}
					</div>
				</div>
			</a>
		</div>
	);
};

export default PortraitItem;
